export default __webpack_public_path__ + "static/media/subcategory_car_1.b0090cac.png";